export default [
  {
    name: 'RoulettesFieldsCompaniesList',
    path: 'settings/companies/roulettes-fields',
    component: () => import('pages/settings/roulettes-fields/RoulettesFieldsCompaniesList.vue')
  },
  {
    name: 'RoulettesFieldsList',
    path: 'settings/companies/:id/roulettes-fields',
    component: () => import('pages/settings/roulettes-fields/RoulettesFieldsList.vue')
  },
  {
    name: 'RoulettesFieldsCreate',
    path: 'settings/companies/:id/roulettes-fields/new',
    component: () => import('pages/settings/roulettes-fields/RoulettesFieldsForm.vue')
  },
  {
    name: 'RoulettesFieldsEdit',
    path: 'settings/companies/:id/roulettes-fields/:rouletteFieldId/edit',
    component: () => import('pages/settings/roulettes-fields/RoulettesFieldsForm.vue')
  },
  {
    name: 'RoulettesFieldsSingle',
    path: 'settings/companies/:id/roulettes-fields/:rouletteFieldId',
    component: () => import('pages/settings/roulettes-fields/RoulettesFieldsSingle.vue')
  }
]
